// extracted by mini-css-extract-plugin
export default {"questionContainer":"styles_questionContainer__jM9Wy","footerStyles":"styles_footerStyles__yKcL0"};